import React from 'react'
import { useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom'
import routes from '.'
import Spinner from '../Spinner'
import EmployeeLayout from '../../layouts/EmployeeLayout'
import StudentLayout from '../../layouts/StudentLayout'

const PrivateRoute = ({ children, requiredRoles }) => {

    const { userInfo, isLoading, isAuthenticated } = useSelector(x => x.user)

    const PermittedLayout = React.useMemo(() => userInfo?.role?.name === "учитель" ? EmployeeLayout : StudentLayout, [userInfo])

    const hasPermission = requiredRoles.includes(userInfo?.role?.name)

    if (isLoading) {
        return <Spinner height="100vh" />
    }

    if (!isLoading && !isAuthenticated && !userInfo) {
        return <Navigate to={routes.login.path} />
    }

    if (!hasPermission) return <Navigate to={routes.main.path} />

    return <PermittedLayout>
        {children}
    </PermittedLayout>
}

export default PrivateRoute